<template>
  <div
    @mouseenter="startPreview"
    @mouseleave="stopPreview"
    class="previewContainer"
  >
    <img 
      :class="{'hideThumbnail': hideThumbnail}"
      :src="defaultThumbnail"
      alt=""
      width="100%"
      height="100%"
      class="rounded img-fluid"
    />
    <div
      v-if="renderPlayer"
      :class="{'hidePlayer': hidePlayer}"
      class="youtube-preview"
      @mouseleave="stopPreview"
    >
      <youtube
        :id="id"
        :video-id="embedId"
        ref="youtube"
        :player-vars="playerVars"
        disablepictureinpicture
        controlslist="nodownload"
        muted
        width="100%"
        height="101%"
        @ready="onReady"
        @playing="playing"
        @paused="paused"
      ></youtube>
    </div>
  </div>
</template>

<script>

// three stages: (thumbnail rendered, player not rendered) => as user hovers (thumbnail rendered, load player but not display) => after 2 sec (hide thumbnail , display player) => (thumbnail , hide player)
/**
 * 144p : &vq=tiny

240p : &vq=small

360p : &vq=medium

480p : &vq=large

720p : &vq=hd720
 */
export default {
  data: function() {
    return {
      id: `preview-${Math.floor(Math.random()*100000)}`,
      playerVars: {
        autoplay: 0,
        controls: 0,
        enablejsapi: 1,
        rel: 0,
        start: 0,
        modestbranding: 1,
        showsearch: 0,
        playsinline: 1,
        vq: 'medium'
      },
      previewHandler: null,
      renderPlayerHandler: null,
      playerReady: false,
      hideThumbnail: false,
      hidePlayer: true,
      renderPlayer: false,
      videoDuration: null,
      continuePreviewHandler: null,
      itr: null,
      previousSkipSuccess: true,
      player: null,

      section: 10,
      sectionPlayTime: 2, // 2sec
      timePoints: [],
      index: -1,
    }
	},
  props: {
    defaultThumbnail: {type: String, default: null }
  },
  computed: {
    embedId() {
      const url = this.defaultThumbnail.replace(/\/[^\/]*$/, '');
      const fragments = url.split('/');
      return fragments.length && fragments[fragments.length-1] || '';
    },
    diff() {
      return (this.videoDuration)/(this.section);
    }
  },
  mounted() {
    this.hideThumbnail = false;
    this.hidePlayer = true;
    this.renderPlayer = false;
  },
  methods: {
    firstMouseEnter() {
      // console.log(`${this.id} first time entered`);
      // 1st time render player.
      this.renderPlayerHandler = setTimeout(async ()=>{
        // console.log(`${this.id} loading the player`);
        this.renderPlayer = true;
        this.hidePlayer = true;
        this.hideThumbnail = false;
      }, 1000);
    },
    async startPreview() {
      if (this.player) {
        // console.log(`${this.id} starting preview`);
        await this.player.playVideo();
        this.previewHandler = setTimeout(async ()=>{
          // console.log(`${this.id} started preview`);
          this.hideThumbnail = true;
          this.hidePlayer = false;
          this.videoDuration = await this.player.getDuration();
          if (this.videoDuration > 0 && !this.hidePlayer) this.continuePreviewLoop();
          else {
            this.hideThumbnail = false;
            this.hidePlayer = true;
            // console.error("video duration in zero!");
          }
        }, 1000);
      } else this.firstMouseEnter();
    },
    stopPreview() {
      // console.log(`${this.id} stoping preview`);
      clearTimeout(this.previewHandler);
      this.previewHandler = null;
      clearTimeout(this.renderPlayerHandler);
      this.renderPlayerHandler = null;
      clearInterval(this.continuePreviewHandler);
      this.continuePreviewHandler = null;
      if (this.player) this.player.pauseVideo();
      this.hideThumbnail = false;
      this.hidePlayer = true;
    },
    async continuePreviewLoop() {
      if (this.hidePlayer) return;
      this.previousSkipSuccess = true;
      await this.player.playVideo();
      if (this.sectionPlayTime < this.diff) {
        this.continuePreviewHandler = setInterval(async ()=> {
          if (this.hidePlayer) {
            this.stopPreview();
          } else if(this.previousSkipSuccess) {
            this.previousSkipSuccess = false;
            await this.player.playVideo();
            await this.player.seekTo(this.nextPointToSkip());
          }
        }, this.sectionPlayTime*1000);
      }
    },
    nextPointToSkip() {
      this.index = (this.index+2) > this.section ? 1:this.index+1;
      this.index = this.index ==0 ? 1: this.index;
      while (this.index >= this.timePoints.length) {
        let time = Math.floor(this.index*this.diff);
        this.timePoints.push(time);
        // console.log(this.timePoints, this.index, this.timePoints[this.index]);
      }
      // console.log(this.timePoints, this.index, this.timePoints[this.index]);
      return this.timePoints[this.index];
    },
    async playing() {
      // console.log('playing');
      setTimeout(() =>  this.previousSkipSuccess = true, this.sectionPlayTime*1000);
      // console.log(await this.player.getPlaybackQuality());
      if(this.index == -1)
        setTimeout(async () => {
          // console.log(this.index, 'stoppping');
          if (this.index == -1) await this.player.pauseVideo();
        }, 2000);
    },
    async paused() {
      // console.log('paused');
    },
    async onReady() {
      this.player = this.$refs.youtube.player;
      // console.log(await this.player.getIframe().then(iframe => iframe.src));
      this.player.mute();
      this.startPreview();
    }
  }
};
</script>
<style lang="scss" scoped>
.hideThumbnail {
  display: none !important;
}
.hidePlayer {
  display: none !important;
}
.previewContainer {
  width: 100%;
  height: 100%;
  display: flex !important;
  align-items: center;
}
.youtube-preview {
  height:  100% !important;
  width: 100% !important;
  display: flex;
  align-items: center;
  pointer-events: none !important;
}
</style>
